import { render, staticRenderFns } from "./b-dropdown-select-account.vue?vue&type=template&id=3bbe0f70&scoped=true"
import script from "./b-dropdown-select-account.vue?vue&type=script&lang=js"
export * from "./b-dropdown-select-account.vue?vue&type=script&lang=js"
import style0 from "./b-dropdown-select-account.vue?vue&type=style&index=0&id=3bbe0f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe0f70",
  null
  
)

export default component.exports